import { render, staticRenderFns } from "./team.vue?vue&type=template&id=9029f99a&scoped=true&lang=pug&"
import script from "./team.vue?vue&type=script&lang=ts&"
export * from "./team.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9029f99a",
  null
  
)

export default component.exports